// extracted by mini-css-extract-plugin
export default {"container":"TimeAndSalesTable_container__Kk333","table":"TimeAndSalesTable_table__BCbAk","tbody":"TimeAndSalesTable_tbody__DjLqU"};